export const environment = {
  /*
    Meter Entry 3.0 properties - for testing purposes
  */
  isMetersOffline: false,
  isSpaceOffline: false,
  isSpaceUnstable: false,
  // end
  /*
    Energiedaten property - for testing purposes
  */
  isEnergiedatenConnectionError: false,
  // end
  energyPortalAppUrl: '',
  registrationRequestRoles: [''],
  tenantName: '',
  idleWatch: '',
  idleInSeconds: '',
  idleTimeoutInSeconds: '',
  idlePingIntervalInSeconds: '',
  environment: '',
  version: '',
  proxyApiURL: '',
  proxyDirectUrl: '',
  proxyMfeUrl: '',
  language: '',
  languageTimezone: '',
  pwaURL: '',
  storungenUrl: '',
  planauskunftPingUrl: '',
  planauskunftCiamUrl: '',
  planauskunftLvn: '',
  webShopUrl: '',
  lvnStreetlightManagerUrl: '',
  eKommuneUrl: '',
  meterReadingLewUrl: '',
  snapLvnUrl: '',
  innoLiveUrl: '',
  innoLiveMoreDetailsUrl: '',
  innoLiveDemoUrl: '',
  myDocumentsUrl: '',
  energyReportUrl: '',
  allowedEnergyDataKomKeys: '',
  allowedMeterReadingKomKeys: '',
  noKomKeyMunicipality: '',
  maintenanceMessage: '',
  maintenanceEndDate: '',
  instrumentationKey: '',
  inquiryEmail: '',
  energieMonitorUrl: '',
  lewenergieMonitorUrl: '',
  sensorWebShopUrl: '',
  energyDataCharts: [] as any[],
  meterMsbContractsEmailRecipients: [] as any[],
  companyGroupEmail: '',
  lieferstellenverwaltungNewSapIsuEmail: '',
  lieferstellenverwaltungVersion: '',
  consumptionWizardHeatProductIds: '',
  ciamUrlPasswordReset: '',
  ciamAppExternalId: '',
  tenant: '',
  contactInquiryTypes: [] as any[],
  scenarioPlannerBudgetLimit: '',
  maxCommentField: 90,
  indicatorText: '',
  lieferstellenverwaltungUrl: '',
  solutionFinderUrl: '',
  antraegeUrl: '',
  producerKPIUrl: '',
  teaserUrl: '',
  eeNetznaviUrl: '',
  debugLog: false,
  dsoDsoUrl: '',
  qualtricsId: '',
  qualtricsUrl: '',
  qualtricsDomainUrl: '',
  isSlpInfoTextEnabled: false,
  appLogicStaticWebsiteUrl: '',
  energieManagementOptimumUrl: '',
  dataProtectionUrl: '',
  heatEmailURL: '',
  sendWorkOrderFailedEmail: false,
  mapSatelliteUsername: '',
  mapSatelliteStyleId: '',
  heatDataEmail: '',
  energyManagementCockpitEnabled: false,
  heatDataNdaPdfFileName: '',
  damageReportPriceListPdf: '',
  features: {
    meterEntryOko: true,
    meterReadingSpaceBulkUpload: false,
    stichtagsablesungRegistration: true,
  },
  featureEnergieMonitorV2Enabled: false,
  captchaServiceUrl: '',
  captchaService2Url: '',
  captchaPublicKey: '',
  gridInfrastructureUrl: '',
  financeReportUrl: '',
};
